import { render, staticRenderFns } from "./MrBtn.vue?vue&type=template&id=78aa831a&scoped=true&lang=pug"
import script from "./MrBtn.vue?vue&type=script&lang=js"
export * from "./MrBtn.vue?vue&type=script&lang=js"
import style0 from "./MrBtn.vue?vue&type=style&index=0&id=78aa831a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78aa831a",
  null
  
)

export default component.exports